(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-horizontal-subcollections"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.subcollection-scroll').forEach((scrollContainer) => {
    if (scrollContainer.dataset.pbScrollInitialized === 'true') return;

    scrollContainer.dataset.pbScrollInitialized = 'true';

    if (scrollContainer.scrollWidth <= scrollContainer.clientWidth + 1) return;

    const menuKey = `subcollectionScrollLeft_${scrollContainer.dataset.menuType || 'default'}`;
    const savedScroll = sessionStorage.getItem(menuKey);

    if (savedScroll !== null) {
      scrollContainer.scrollLeft = Number.parseInt(savedScroll, 10) || 0;
    }

    scrollContainer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        sessionStorage.setItem(menuKey, String(scrollContainer.scrollLeft));
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
